import Vue from 'vue'
import Router from 'vue-router'
import {adminRouter} from './admin'
import {projectOfficeRouter} from './projectOffice'
import {trainRouter} from './train'
import {practiceBaseRouter} from './practiceBase'
import {fuseRouter} from './fuse'
import {examinationRouter} from './examination'
import {coordinateRouter} from './coordinate'
import {applyRouter} from './apply'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: () => {
      return '/login'
    }
  },
  {
    path: '/login',
    component: () =>
      import ('../views/login'),
    meta: {
      title: '社会组织人才考试系统-登录',
    }
  },
  {
    path: '/forget',
    component: () =>
      import ('../views/forget'),
    meta: {
      title: '社会组织人才考试系统-忘记密码',
    }
  },
  {
    path: '/home',
    component: () =>
      import ('../views/home'),
    meta: {
      title: '社会组织人才考试系统-角色选择',
    }
  },
  //  总管理员
  {
    path: '/admin',
    component: () =>
      import ('../views/admin/home'),
    children: adminRouter,
  },
  //  项目办
  {
    path: '/projectOffice',
    component: () =>
      import ('../views/projectOffice/home'),
    children: projectOfficeRouter,
  },
  //  认证培训机构
  {
    path: '/train',
    component: () =>
      import ('../views/train/home'),
    children: trainRouter,
  },
  //  实习基地
  {
    path: '/practiceBase',
    component: () =>
      import ('../views/practiceBase/home'),
    children: practiceBaseRouter,
  },
  //  产教融合基地
  {
    path: '/fuse',
    component: () =>
      import ('../views/fuse/home'),
    children: fuseRouter,
  },
  //  考场
  {
    path: '/examination',
    component: () =>
      import ('../views/examination/home'),
    children: examinationRouter,
  },
  //  协调中心
  {
    path: '/coordinate',
    component: () =>
      import ('../views/coordinate/home'),
    children: coordinateRouter,
  },
  //  机构申请
  {
    path: '/apply',
    component: () =>
      import ('../views/apply/home'),
    children: applyRouter,
  },
]

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return {x: 0, y: 0}
  }
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to){
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
